import { Link } from "react-router-dom";
import heroBanner from '../img/NAS Peer Befriending_450_plus.png';
import HeroBannerComp from "../elements/herobanner/HeroBannerComp";
import "../elements/herobanner/herobanner.css";
import { pbJoinLink } from "../data/Data";

const homeCards = [
  {
    title: "Peer Befriending",
    text: "A free, online program that pairs people with aphasia for support and friendship.",
    to: "/peer-befriending",
    className: "home-card--purple",
  },
  {
    title: "Adaptive Growth Culture",
    text: "Simple, practical tools to help people with aphasia thrive.",
    to: "/adaptive-growth-culture",
    className: "home-card--teal",
  },
  {
    title: "Resources",
    text: "What is aphasia? Newsletters, videos, and community resources.",
    to: "/resources",
    className: "home-card--orange",
  },
];

export default function Home() {
  return (
    <>
      <div className="hero-home">
        <div id="hero">
          <HeroBannerComp
            className="heroBanner"
            image={heroBanner}
            title="NAS Peer Befriending Program — all about hope"
            ctaLabel="Join Today!"
            ctaTo={pbJoinLink}
          />
        </div>
      </div>

      <div className="page">
        <p className="lead">
          National Aphasia Synergy (NAS) is a peer-led non-profit organization designed to support
          people with aphasia. The NAS philosophy is for people with aphasia to help other people
          with aphasia thrive.
        </p>

        <div className="home-cards">
          {homeCards.map(({ title, text, to, className }) => (
            <Link key={to} to={to} className={`home-card ${className}`}>
              <h2>{title}</h2>
              <p>{text}</p>
              <span className="home-card__more">Learn more →</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
